import {
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { TabListProps, tabListStyles } from '@kite_aerolab/shared/components';
import { TabComponent } from './tab.component';
import { scrollElement } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-tab-list',
  template: `
    <div
      #ref
      [ngClass]="tabListStyles"
      role="tablist"
      aria-orientation="horizontal"
      (keydown)="handleKeyboardNavigation($event)"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class TabListComponent {
  activeIndex = 0;
  tabs: any[];
  tabsRefs: any[];

  @ContentChildren(TabComponent) childrenTabs: QueryList<TabComponent>;
  @ContentChildren(TabComponent, { read: ElementRef }) childrenTabRefs: QueryList<TabComponent>;
  @ViewChild('ref', { static: false }) divRef: ElementRef;
  @Input() align: TabListProps['align'];
  @Input() css: TabListProps['css'];

  @Output() onTabChange = new EventEmitter();

  public get tabListStyles(): string[] {
    return [
      tabListStyles({
        align: this.align,
        css: this.css,
      }).className,
    ];
  }

  searchNextIndex(active: number) {
    const next = active + 1;
    if (next > this.tabs.length - 1) return 0;
    return this.tabs[next].id;
  }

  searchPrevIndex(active: number) {
    const prev = active - 1;
    if (prev < 0) return this.tabs[this.tabs.length - 1].id;
    return this.tabs[prev].id;
  }

  selectTab(id: number, event: 'click' | 'key' = 'click') {
    this.activeIndex = id;

    this.tabs.forEach((tab) => {
      tab.isActive = false;
    });

    event === 'key' ? (this.tabs[id].isFocusable = true) : (this.tabs[id].isFocusable = false);

    this.tabs[id].isActive = true;
    this.onTabChange.emit(this.tabs[id].content);
  }

  handleKeyboardNavigation(event: any) {
    if (event.key === 'ArrowRight') {
      this.selectTab(this.searchNextIndex(this.activeIndex), 'key');
    } else if (event.key === 'ArrowLeft') {
      this.selectTab(this.searchPrevIndex(this.activeIndex), 'key');
    }
  }

  ngAfterViewInit() {
    this.tabs = this.childrenTabs
      .toArray()
      .map((tab) => (!tab.isDisabled ? tab : null))
      .filter((i) => i !== null);

    this.tabsRefs = this.childrenTabRefs
      .toArray()
      .map((tab) => (!tab.isDisabled ? tab : null))
      .filter((i) => i !== null);

    this.childrenTabs.forEach((tab, index) => {
      tab.content = index;
      tab.id = this.tabs.findIndex((t) => t === tab);
      // setea que cuando la tab emite el evento onClick, se llame la función para seleccionarla
      tab.onClick.subscribe(() => {
        this.selectTab(tab.id || 0);
      });
    });

    const selectedTab = this.tabs.findIndex((tab) => {
      return tab.isActive === true;
    });

    this.selectTab(selectedTab !== -1 ? selectedTab : 0);

    // Agrega a todo el list el scroll horizontal si las tabs exceden el ancho de la pantalla
    scrollElement(this.divRef.nativeElement);
  }
}
